export const column2object = (columns: any[]) => {
  return {
    disabled: !!columns[2],
    name: columns[3] || "",
    background: columns[4] || "",
    description: columns[5] || "",
    order: columns[6] || "",
  }
}
